import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "bg-gray-50 px-6 py-4 border-t border-gray-200 flex-shrink-0" };
const _hoisted_2 = {
    key: 0,
    class: "mb-3 flex items-start gap-2 text-sm text-red-600"
};
const _hoisted_3 = { class: "flex gap-3 items-center" };
const _hoisted_4 = ["disabled"];
const _hoisted_5 = {
    key: 1,
    disabled: "",
    class: "flex-1 bg-gray-300 text-gray-500 py-3 px-6 rounded-lg font-semibold cursor-not-allowed flex items-center justify-center"
};
import { computed } from 'vue';
import { useTheme } from '@shared/composables/useTheme';
import QuantitySelector from './QuantitySelector.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfigFooter',
    props: {
        product: {},
        quantity: {},
        canAddToCart: { type: Boolean },
        formattedButtonPrice: {},
        pricingError: {},
        isPriceLoading: { type: Boolean }
    },
    emits: ["add-to-cart", "increase-quantity", "decrease-quantity", "highlight-invalid"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // When the button is tapped: add to cart if valid, otherwise ask the
        // parent to scroll to + highlight the first unfilled mandatory group.
        const handleClick = () => {
            if (props.isPriceLoading)
                return;
            if (props.canAddToCart) {
                emit('add-to-cart');
            }
            else {
                emit('highlight-invalid');
            }
        };
        const { theme } = useTheme();
        const themePrimaryColor = computed(() => theme.value.colors.primary);
        const themeBorderRadius = computed(() => theme.value.borderRadius);
        const buttonStyle = computed(() => {
            if (!props.canAddToCart)
                return undefined;
            return {
                backgroundColor: themePrimaryColor.value,
                borderRadius: themeBorderRadius.value
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.pricingError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-triangle-exclamation mt-0.5" }, null, -1 /* CACHED */)),
                        _createElementVNode("span", null, "Preisberechnung fehlgeschlagen: " + _toDisplayString(_ctx.pricingError), 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_3, [
                    _createCommentVNode(" Quantity Selector "),
                    _createVNode(QuantitySelector, {
                        quantity: _ctx.quantity,
                        "is-available": _ctx.product?.available ?? false,
                        onIncrease: _cache[0] || (_cache[0] = ($event) => (emit('increase-quantity'))),
                        onDecrease: _cache[1] || (_cache[1] = ($event) => (emit('decrease-quantity')))
                    }, null, 8 /* PROPS */, ["quantity", "is-available"]),
                    _createCommentVNode(" Add to Cart Button "),
                    (_ctx.product?.available)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: handleClick,
                            disabled: _ctx.isPriceLoading,
                            class: _normalizeClass(["flex-1 py-3 px-6 rounded-lg font-semibold transition-all duration-200 flex items-center justify-center",
                                _ctx.canAddToCart && !_ctx.isPriceLoading
                                    ? 'text-white cursor-pointer hover:opacity-90'
                                    : _ctx.isPriceLoading
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-gray-400 text-white cursor-pointer hover:bg-gray-500'
                            ]),
                            style: _normalizeStyle(_ctx.canAddToCart && !_ctx.isPriceLoading ? buttonStyle.value : undefined)
                        }, [
                            (_ctx.isPriceLoading)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1 /* CACHED */)),
                                    _cache[4] || (_cache[4] = _createTextVNode(" Berechnung... ", -1 /* CACHED */))
                                ], 64 /* STABLE_FRAGMENT */))
                                : (_ctx.canAddToCart)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-cart-plus mr-2" }, null, -1 /* CACHED */)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.formattedButtonPrice), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createCommentVNode(" Mobile: only the icon. Desktop: icon + hint text "),
                                        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-exclamation-circle sm:mr-2" }, null, -1 /* CACHED */)),
                                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "hidden sm:inline" }, "Bitte Pflichtfelder ausfüllen", -1 /* CACHED */))
                                    ], 64 /* STABLE_FRAGMENT */))
                        ], 14 /* CLASS, STYLE, PROPS */, _hoisted_4))
                        : (_openBlock(), _createElementBlock("button", _hoisted_5, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "fas fa-times-circle mr-2" }, null, -1 /* CACHED */),
                                _createTextVNode(" Nicht verfügbar ", -1 /* CACHED */)
                            ]))]))
                ])
            ]));
        };
    }
});
